import BaseApp from '@spa/apps/trustup-pro-base-js/BaseApp';
import WebsocketListener from './WebsocketListener';
import OpportunityEndpoint from './endpoints/OpportunityEndpoint';
import OpportunityMeetingEndpoint from './endpoints/OpportunityMeetingEndpoint';
import WorksiteEndpoint from './endpoints/WorksiteEndpoint';
import WorksitePlanningEndpoint from './endpoints/WorksitePlanningEndpoint';
import TrustUpIOTaskTimeActivityEndpoint from './endpoints/TrustUpIOTaskTimeActivityEndpoint';
import WorksiteTimeActivityEndpoint from './endpoints/WorksiteTimeActivityEndpoint';
import WorksitePhaseEndpoint from './endpoints/WorksitePhaseEndpoint';
import WorksiteProfitabilityDocumentEndpoint from './endpoints/WorksiteProfitabilityDocumentEndpoint';
import WorksiteFileEndpoint from './endpoints/WorksiteFileEndpoint';
import WorksiteFileFolderEndpoint from './endpoints/WorksiteFileFolderEndpoint';
import WorksiteTaskEndpoint from './endpoints/WorksiteTaskEndpoint';
import WorksiteTaskColumnEndpoint from './endpoints/WorksiteTaskColumnEndpoint';
import WorksiteTaskGroupEndpoint from './endpoints/WorksiteTaskGroupEndpoint';

export default class Worksite extends BaseApp
{

    setup()
    {
        this.endpoints = {
            opportunity: new OpportunityEndpoint(),
            opportunityMeeting: new OpportunityMeetingEndpoint(),

            worksite: new WorksiteEndpoint(),
            worksitePlanning: new WorksitePlanningEndpoint(),
            worksiteProfitabilityDocument: new WorksiteProfitabilityDocumentEndpoint(),
            worksitePhase: new WorksitePhaseEndpoint(),
            worksiteFile: new WorksiteFileEndpoint(),
            worksiteFileFolder: new WorksiteFileFolderEndpoint(),
            worksiteTimeActivity: new WorksiteTimeActivityEndpoint(),
            worksiteTask: new WorksiteTaskEndpoint(),
            worksiteTaskGroup: new WorksiteTaskGroupEndpoint(),
            worksiteTaskColumn: new WorksiteTaskColumnEndpoint(),
            
            trustUpIoTaskTimeActivity: new TrustUpIOTaskTimeActivityEndpoint(),
        };

        this.websocketListener = new WebsocketListener().init();
    }

    // getComponentsPath()
    // {
    //     return './components';
    // }

}